import { Component, ViewEncapsulation } from '@angular/core';
import { IInformationModal } from '@interfaces/modal.interface';

@Component({
    selector: 'app-information-modal',
    templateUrl: './information-modal.component.html',
    styleUrls: ['./information-modal.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})

export class InformationModalComponent{
  public data: IInformationModal;
}
